import "D:\\coding\\pmv5-fe\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "D:\\coding\\pmv5-fe\\node_modules\\core-js\\modules\\es6.promise.js";
import "D:\\coding\\pmv5-fe\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "D:\\coding\\pmv5-fe\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from "vue";
import router from "./config/router";
import store from "./config/store";
import { getOperateAuth } from '@/config/operateAuth';
import "./config/http";
import moment from 'moment';
import iView, { Input, Switch, Modal, Message, Notice, Col } from "iview";
import "./styles/index.less";
import "./styles/pmv5.css";
import App from "./App.vue";
Vue.use(iView);

// 根据官方文档：https://www.iviewui.com/docs/guide/start#ZJSYGF
// 使用组件
//   Button, Col, Table, Input, Form, Menu, Select, Option, Progress, Time, Switch, Circle
// 时，可能需要添加 I 前缀避免冲突，下面的组件在 vscode 中语法识别时报错，所以添加了前缀
// 如果后面发现其它组件存在类似问题，也添加到下面
Vue.component("IInput", Input);
Vue.component("ICol", Col);
Vue.component("ISwitch", Switch);
Vue.prototype.$Modal = Modal;
// 关闭 ESC 按键
Modal.props.closable.default = false;
// 关闭点击 modal 外 mask 部分
Modal.props.maskClosable.default = false;
Vue.prototype.$Message = Message;
Vue.prototype.$Notice = Notice;
// moment
Vue.prototype.$moment = moment;
// 通用菜单、按钮权限判断方法
Vue.prototype.$getOperateAuth = getOperateAuth;
new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');